import Orgchart from './orgchart.element.js';

export default Orgchart;

Orgchart.define('wje-orgchart', Orgchart);
